/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateComboResponseSchemaSchema } from "./calculateComboResponseSchemaSchema.ts";
import { comboCalculationRequestRequestSchema } from "./comboCalculationRequestRequestSchema.ts";

export const combosCalculateCreatePathOrgUnitIdSchema = z.uuid();

export const combosCalculateCreateStatus200Schema = calculateComboResponseSchemaSchema;

export const combosCalculateCreateResponseSchema = combosCalculateCreateStatus200Schema;

export const combosCalculateCreateDataSchemaJson = comboCalculationRequestRequestSchema.optional();

export const combosCalculateCreateDataSchemaXml = comboCalculationRequestRequestSchema.optional();

export const combosCalculateCreateDataSchema = z.union([combosCalculateCreateDataSchemaJson, combosCalculateCreateDataSchemaXml]);
